import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { get } from 'lodash';

import { changeLocale } from '@lib/actions';
import { Locale } from '@lib/providers/LanguageProvider/LanguageProvider';
import { patientsResource } from '@lib/resources';
import { selectCurrentUser } from '@lib/selectors';
import { EModule, FallbackButtonLocale, ModuleWrapper } from '@lumahealthhq/ui-common';

const ButtonLocale = React.lazy(() => import('remote_common/ButtonLocale'));

export interface LanguageSelectorProps {}

const LanguageSelector: React.FC<LanguageSelectorProps> = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);

  const handleChange = useCallback(
    (locale: Locale) => {
      dispatch(changeLocale(locale));
      const patientId = get(currentUser, 'id');
      if (patientId) {
        dispatch(
          patientsResource.request({
            method: 'put',
            url: `/patients/${patientId}/language`,
            data: {
              // Model accepts language only, not language-country
              language: locale.split('-')[0],
            },
            meta: {
              ignoreErrors: true,
            },
          }),
        );
      }
    },
    [dispatch, currentUser],
  );

  return (
    <ModuleWrapper module={EModule.ButtonLocale} fallback={<FallbackButtonLocale />} ignoreAuth>
      <ButtonLocale onChange={handleChange} />
    </ModuleWrapper>
  );
};

export default LanguageSelector;
